// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseVehiclePlansAreaRoutes = {
  route: '/vehicle-plans',
  Templates: {
    route: '/templates',
  },
}

export const VehiclePlansAreaRoutes = transformRoutes(
  BaseVehiclePlansAreaRoutes,
)
